import { useEffect } from "react";

export default function useSeo({
  title,
  description,
  canonical,
  ogImage,
  noIndex = false,
  jsonLd,
}) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (key, content, attr = "name") => {
      let tag = document.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    if (description) setMeta("description", description);
    if (title) setMeta("og:title", title, "property");
    if (description) setMeta("og:description", description, "property");
    if (ogImage) setMeta("og:image", ogImage, "property");

    setMeta("robots", noIndex ? "noindex,nofollow" : "index,follow");

    if (canonical) {
      let link = document.querySelector(`link[rel="canonical"]`);
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [title, description, canonical, ogImage, noIndex, jsonLd]);
}
